import {FunctionComponent} from 'react'

import { Card, CardContent } from '@mui/material';

export interface ErrorContainerProps {
  text?: string;
  height: string;
  errorToolbar?: any;
}

export const ErrorContainer: FunctionComponent<ErrorContainerProps> = ({text, height, errorToolbar}) => {
  return (
    <Card variant='outlined' style={{maxWidth:"md", height: height}}>
      {errorToolbar?<>{errorToolbar}</>:
        <CardContent style={{
          textAlign: "center",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <span>{text}</span>
        </CardContent>}
    </Card>
  )
}